<template>
  <div>
    <button
      v-if="data.status == 'PENDING'"
      class="btn dealers_btn"
      @click="deleteRequest(data)"
    >
      {{ $t("text.actionButtons.delete") }}
    </button>
    <button v-else class="btn dealers_btn disabled" style="cursor: not-allowed">
      {{ $t("text.actionButtons.delete") }}
    </button>
  </div>
</template>

<script>
import configObject from "@/config";
import Jquery from "jquery";
let $ = Jquery;

export default {
  data() {
    return {
      data: {},
    };
  },
  methods: {
    deleteRequest(data) {
      const response = confirm(this.$t("text.products.sureDeleteRequest"));
      if (!response) {
        return;
      }
      this.axios
        .delete(
          `${configObject.apiBaseUrl}/SettlementRequest/Branch/DeleteRequest/${this.data.id}`,
          configObject.authConfig()
        )
        .then(() => {
          this.$eventHub.$emit("getSettlementRequest");
          this.$toast.open({
            message: this.$t("text.products.requestDeleted"),
            type: "success",
            duration: 5000,
          });
          this.$eventHub.$emit("getSettlementRequest");
        })
        .catch((error) => {
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 5000,
          });
        });
    },
  },
};
</script>
